<template>
    <div class="body">
        <div class="header">
            <p>首页</p>
            <div @click="onPressNav('goodsList', {shop_id: 2})">
                <img :src="Images.icon_search" alt="">
                <p>输入关键字搜索</p>
                <div></div>
                <span>搜索</span>
            </div>
        </div>
        <div class="scrollerView" :style="{ height: (wrapperHeight- 116) + 'px' }">
            <div class="swiper">
                <van-swipe :autoplay="5000" indicator-color="white">
                    <van-swipe-item v-for="(item, index) in dataSources.shop_banner" :key="index">
                        <a :href="item.link_url">
                            <img :src="item.img_url">
                        </a>
                    </van-swipe-item>
                </van-swipe>
            </div>
            <div class="menu">
                <div v-for="(item, index) in dataSources.goods_category_list" :key="index" @click="onPressNav('goodsList', {shop_id: 2, cate_id: item.id, cate_name: item.name})">
                    <img :src="item.image" alt="">
                    <p>{{item.name}}</p>
                </div>
            </div>
            <div class="list" v-for="(item, index) in dataSources.shop_category_list" :key="index">
                <div class="list-header">
                    <div class="left"></div>
                    <p>{{item.category_name}}</p>
                    <div class="more" @click="onPressNav('goodsList', {shop_id: 2, cate_id: item.cate_id, cate_name: item.category_name, eq_shop_category_id: item.id})">更多 >></div>
                </div>
                <div class="list-body" v-if="item.category_name==='文化工艺品'">
                    <div class="item1" v-for="(_item, _index) in item.goods_list" :key="_index" @click="onPressNav('goodsDetail', {id: _item.id})">
                        <img :src="_item.home_image || _item.image" alt="">
                        <p class="none">{{_item.cate_name}}</p>
                        <span class="mt-1">{{_item.sku_field_name}}</span>
                    </div>
                </div>
                <div class="list-body" v-else>
                    <div class="item2" v-for="(_item, _index) in item.goods_list" :key="_index" @click="onPressNav('goodsDetail', {id: _item.id})">
                        <div>
                            <p>{{_item.cate_name}}</p>
                            <div></div>
                            <span>{{_item.sku_field_name}}</span>
                        </div>
                        <img :src="_item.home_image || _item.image" alt="">
                    </div>
                </div>
            </div>
        </div>
        <FooterShop @showLoginDialog="_showLoginDialog" :idx="1" />
    </div>
</template>
<script>
import FooterShop from '@/components/FooterShop'
export default {
    /** 组件挂载 */
    components: {
        'FooterShop': FooterShop,
    },
    /** 数据区 */
    data() {
        return {
            wrapperHeight: 0, //屏幕高度 - 脚部
            dataSources: {
                shop_banner: [],
                goods_category_list: [],
                shop_category_list: [{
                        category_name: "文化工艺品",
                        category_num: "6",
                        goods_list: [],
                    },
                    {
                        category_name: "主题工艺品",
                        category_num: "6",
                        goods_list: [],
                    },
                ]
            },
        };
    },
    /** 挂载后 */
    mounted() {
        this.wrapperHeight = document.documentElement.clientHeight;
        this.requestData();
    },
    /** 方法 */
    methods: {

        // 未登录时显示登录弹窗
        _showLoginDialog(value) {
            console.log('_showLoginDialog---->', value);
            this.$emit(this.Constants.SHOWLOGINDIALOG, true);
        },

        // 点击跳转
        onPressNav(router, query = {}) {
            this.$router.push({ path: '/' + router, query: query })
        },
        // 请求首页数据
        async requestData() {
            let url = this.API.shop_home;
            let params = {
                shop_id: 2, // 1商城一  2商城二
            };
            let result = await this.$post(url, params);
            console.log(this.GLOBAL.SUCCESS_CODE)
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.dataSources = result.data
                console.log('result.data', result.data)
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
    },
};
</script>
<style lang="less" scoped>
.body {
    background-color: #fff;
}

.header {
    padding: 15px;
    display: flex;
    align-items: center;

    >p {
        padding: 0 10px;
        font-size: 16px;
        color: #333;
    }

    >div {
        flex: 1;
        height: 30px;
        padding: 0 15px;
        border-radius: 5px;
        background: #f1f1f1;
        display: flex;
        align-items: center;

        img {
            width: 14px;
            height: 14px;
        }

        p {
            flex: 1;
            margin: 0 10px;
            font-size: 12px;
            color: #999
        }

        div {
            width: 1px;
            height: 15px;
            background: #999;
        }

        ::-webkit-input-placeholder {
            color: #999
        }

        span {
            padding: 0 0 0 10px;
            font-size: 14px;
            color: #666;
        }
    }
}

.scrollerView {
    position: relative;
    width: 100%;
    overflow-y: auto;
}

.swiper {
    height: 40vw;
    box-sizing: border-box;
    margin: 0 15px;
    border-radius: 6px;
    overflow: hidden;

    img {
        height: 40vw;
        width: 100%;
        object-fit: cover;
    }
}

.menu {
    margin: 15px 0;
    display: flex;

    div {
        width: 25%;
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
            width: 70px;
            height: 70px;
            margin-bottom: 5px;
            border-radius: 50%;
            object-fit: cover;
        }

        p {
            font-size: 14px;
            color: #333;
        }
    }
}

.list {
    margin: 0 0 15px 15px;

    .list-header {
        padding-right: 15px;
        display: flex;
        align-items: center;

        .left {
            width: 4px;
            height: 18px;
            background: linear-gradient(225deg, #9cb2f4, #6472e8);
        }

        p {
            flex: 1;
            margin: 0 10px;
            font-size: 15;
            color: #333;
        }

        .more {
            height: 2rem;
            color: #7181EB;
            padding: 0 1rem;
            font-size: 1.2rem;
            line-height: 2rem;
            border-radius: 2rem;
            background: #F1F3FF;
            border: 1px solid #7181EB;
        }
    }

    .list-body {
        // margin: 0 0 0 15px;
        display: flex;
        flex-wrap: wrap;

        
        .item1 {
            margin: 10px 10px 0 0;
            padding: 10px 0;
            width: calc(calc(100% / 3) - 12.5px);
            border-radius: 10px;
            background: #bcbcbc;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;

            img {
                width: 65px;
                height: 65px;
                object-fit: contain;
            }

            p {
                margin: 4px 0;
                font-size: 15px;
                color: #fff;
            }

            span {
                font-size: 12px;
                color: #fff;
            }
        }

        >.item2 {
            margin: 10px 15px 0 0;
            padding: 10px 10px;
            width: calc(50% - 35px);
            height: 78px;
            border-radius: 10px;
            background: #bcbcbc;
            display: flex;
            align-items: center;
            justify-content: space-around;

            >div {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                p {
                    font-size: 14px;
                    color: #fff;
                }

                >div {
                    width: 36px;
                    height: 1px;
                    margin: 4px 0 6px;
                    border-bottom: 1px solid;
                    border-image: linear-gradient(244deg, #bcbcbc, #ffffff) 1 1;
                }

                span {
                    font-size: 12px;
                    color: #fff;
                }
            }

            img {
                width: 80px;
                height: 80px;
                flex-shrink: 0;
                margin-left: 10px;
                object-fit: cover;
                border-radius: 10px;
            }
        }
    }
}
</style>